var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M7.00004 13.6667C10.6819 13.6667 13.6667 10.6819 13.6667 7.00001C13.6667 3.31811 10.6819 0.333344 7.00004 0.333344C3.31814 0.333344 0.333374 3.31811 0.333374 7.00001C0.333374 10.6819 3.31814 13.6667 7.00004 13.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.00004 6.06668C7.17685 6.06668 7.34642 6.13692 7.47145 6.26194C7.59647 6.38697 7.66671 6.55654 7.66671 6.73335V9.84001C7.66671 10.0168 7.59647 10.1864 7.47145 10.3114C7.34642 10.4364 7.17685 10.5067 7.00004 10.5067C6.82323 10.5067 6.65366 10.4364 6.52864 10.3114C6.40361 10.1864 6.33337 10.0168 6.33337 9.84001V6.73335C6.33337 6.55654 6.40361 6.38697 6.52864 6.26194C6.65366 6.13692 6.82323 6.06668 7.00004 6.06668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.00008 5.16001C7.46032 5.16001 7.83341 4.78692 7.83341 4.32668C7.83341 3.86644 7.46032 3.49335 7.00008 3.49335C6.53984 3.49335 6.16675 3.86644 6.16675 4.32668C6.16675 4.78692 6.53984 5.16001 7.00008 5.16001Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation2);
export default __webpack_public_path__ + "static/media/information2.0deb8edd7b23d254ffd399a00f14829a.svg";
export { ForwardRef as ReactComponent };